export default __webpack_public_path__ + "static/media/machines.bf2a47eb.svg";